import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

function Footer({ navigateToAnchor }) {
    const linkBtnClass = "footer-link bg-transparent border-0 p-0";
    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    return (
        <footer className="site-footer mt-auto">
            <Container>
                <Row className="gy-4 align-items-start">
                    <Col lg={5} md={12} className="mb-3 mb-lg-0">
                        <div className="d-flex align-items-center mb-3 brand">
                            <img
                                src={`${process.env.PUBLIC_URL || ''}/srl-advisor-logo-192-white.png`}
                                alt=""
                                className="brand-logo"
                                height={32}
                            />
                            <span className="brand-name">SRL Advisor</span>
                        </div>
                        <p className="footer-tag mb-3">
                            A Moodle-integrated tool for self-regulated learning. PhD research at the
                            University of St Andrews; built for schools and universities that want real
                            visibility into how their students learn.
                        </p>
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                            <span className="dotsep" aria-hidden="true">·</span>
                            <a href="mailto:hello@srladvisor.com">hello@srladvisor.com</a>
                        </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">Product</p>
                        <ul className="list-unstyled footer-list">
                            <li><button onClick={(e) => goAnchor(e, 'how')} className={linkBtnClass}>How it works</button></li>
                            <li><button onClick={(e) => goAnchor(e, 'research')} className={linkBtnClass}>Research roots</button></li>
                            <li><button onClick={(e) => goAnchor(e, 'roadmap')} className={linkBtnClass}>Roadmap</button></li>
                        </ul>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">For you</p>
                        <ul className="list-unstyled footer-list">
                            <li><button onClick={(e) => goAnchor(e, 'institutions')} className={linkBtnClass}>For institutions</button></li>
                            <li><button onClick={(e) => goAnchor(e, 'about')} className={linkBtnClass}>About Andrew</button></li>
                            <li><button onClick={(e) => goAnchor(e, 'contact')} className={linkBtnClass}>Get in touch</button></li>
                            <li><a href="mailto:hello@srladvisor.com">Email us</a></li>
                        </ul>
                    </Col>
                    <Col lg={3} md={4} sm={12}>
                        <p className="footer-heading">Elsewhere</p>
                        <ul className="list-unstyled footer-list">
                            <li><a href="https://research-portal.st-andrews.ac.uk/en/persons/andrew-schwabe/" target="_blank" rel="noopener noreferrer">St Andrews research portal</a></li>
                            <li><a href="https://scholar.google.com/citations?user=zBPTh_8AAAAJ&hl=en" target="_blank" rel="noopener noreferrer">Google Scholar</a></li>
                            <li><a href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                        </ul>
                    </Col>
                </Row>
                <Row className="footer-rule mt-4 pt-3">
                    <Col md={8} className="footer-fineprint">
                        &copy; {new Date().getFullYear()} Andrew Schwabe &middot; SRL Advisor is doctoral research at the University of St Andrews.
                    </Col>
                    <Col md={4} className="footer-fineprint text-md-end">
                        <Link to="/privacy">Privacy</Link> &middot; <Link to="/accessibility">Accessibility</Link> &middot; <a href="mailto:hello@srladvisor.com">hello@srladvisor.com</a>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
